import { render, staticRenderFns } from "./setting_user_two_factor.vue?vue&type=template&id=2f43dd2c&scoped=true"
import script from "./setting_user_two_factor.vue?vue&type=script&lang=ts"
export * from "./setting_user_two_factor.vue?vue&type=script&lang=ts"
import style0 from "./setting_user_two_factor.vue?vue&type=style&index=0&id=2f43dd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43dd2c",
  null
  
)

export default component.exports